import axiosInstance from './axiosInstance';

export const userLogin = (username, password) =>
    axiosInstance.post("/User/UserLogin", { username, password });

export const isUserAuthenticated = () =>
    axiosInstance.get("/User/isUserAuthenticated");

// Reactivation requests. The request itself is ANONYMOUS — it is raised from the
// login screen by somebody who, by definition, cannot log in — and always answers
// the same way so it cannot be used to discover which usernames exist.
// Listing and deciding are Super Admin only. (user 2026-10-29)
export const requestReactivation = (username, reason) =>
    axiosInstance.post("/User/RequestReactivation", { username, reason });

export const getPendingReactivationRequests = () =>
    axiosInstance.get("/User/GetPendingReactivationRequests");

export const approveReactivationRequest = (requestId, remarks) =>
    axiosInstance.post(`/User/ApproveReactivationRequest/${requestId}`, { remarks });

export const rejectReactivationRequest = (requestId, remarks) =>
    axiosInstance.post(`/User/RejectReactivationRequest/${requestId}`, { remarks });

// Self-service password reset — backed by AuthController.
// requestPasswordReset always returns { ok: true } regardless of whether the
// email exists (anti-enumeration). resetPassword validates the one-time token
// from the emailed link and updates the user's password.
export const requestPasswordReset = (email) =>
    axiosInstance.post("/Auth/ForgotPassword", { email });

export const resetPassword = (token, newPassword) =>
    axiosInstance.post("/Auth/ResetPassword", { token, newPassword });

// Current roles/rights for the logged-in user, read on app boot so a permission
// change lands without a re-login. (user 2026-09-27)
export const getMyRights = () =>
    axiosInstance.get("/User/MyRights");

// One click settles the welcome banner for the ACCOUNT, on every device.
// (user 2026-10-02)
export const dismissJoinGroups = () =>
    axiosInstance.post("/User/DismissJoinGroups");

export const getAllAgents = () =>
    axiosInstance.get("/User/GetAllAgents");

export const getAllAgentGroups = () =>
    axiosInstance.get("/User/GetAllAgentGroups");

// The caller's own recruits — name + status, nothing else. Self-scoped on the
// server: it reads the caller's id off the token, so there is no id to pass and
// no way to ask for somebody else's team.
export const getMyDownline = () =>
    axiosInstance.get("/User/GetMyDownline");

export const getAgentDetailsByAgentId = (agentId) =>
    axiosInstance.get(`/User/GetAgentDetailsById?agentId=${agentId}`);

export const getAgentsByGroupId = (groupId) =>
    axiosInstance.get(`/User/GetAgentsByGroupId?groupId=${groupId}`);

export const updateUserPassword = (userId, currentPassword, newPassword) =>
    axiosInstance.put("/User/UpdateUserPassword", { userId, currentPassword, newPassword });

export const createUser = (request) =>
    axiosInstance.post("/User/CreateUser", request);

export const updateUser = (request) =>
    axiosInstance.put("/User/UpdateUser", request);

export const adminResetPassword = (userId, newPassword) =>
    axiosInstance.put("/User/AdminResetPassword", { userId, newPassword });

export const impersonateUser = (targetUserId) =>
    axiosInstance.post(`/User/Impersonate?targetUserId=${targetUserId}`);

// Inactive-agent auto-deactivation (Super Admin only — the sole role holding
// the UserManagement right).
export const getDeactivationPreview = () =>
    axiosInstance.get("/User/DeactivationPreview");

export const reactivateUser = (userId) =>
    axiosInstance.put(`/User/ReactivateUser/${userId}`);

export const getCommissionHistory = (userId) =>
    axiosInstance.get(`/User/GetCommissionHistory?userId=${userId}`);

export const updateProfile = (request) =>
    axiosInstance.put("/User/UpdateProfile", request);

export const uploadProfilePhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post("/User/UploadProfilePhoto", formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const setUserProcessingFee = (userId, enabled) =>
    axiosInstance.put("/User/SetProcessingFee", { userId, enabled });

// --- Telegram sale-bot linking ---
export const generateTelegramLinkCode = () =>
    axiosInstance.post("/User/GenerateTelegramLinkCode");

export const getTelegramLinkStatus = () =>
    axiosInstance.get("/User/GetTelegramLinkStatus");

export const unlinkTelegram = () =>
    axiosInstance.post("/User/UnlinkTelegram");

// Buddy team allocations — every relationship (ended ones included) with the upline's
// team and the dates it applied. Used ONLY by the Sales Report's group charts, which
// resolve each sale against its own deposit date. (user 2026-08-26)
export const getBuddyTeamAllocations = () =>
    axiosInstance.get("/UserBuddy/team-allocations");

// ── The caller's own IC photocopy ────────────────────────────────────
// Scoped to the caller on the server; there is deliberately NO userId parameter, so
// nothing here can be pointed at somebody else's document. It is also not a static
// file - a government ID does not belong behind a guessable URL.
// (user 2026-10-23: "need to have another input to add ic")
export const uploadMyIcPhoto = (file) => {
    const form = new FormData();
    form.append('file', file);
    return axiosInstance.post('/User/UploadMyIcPhoto', form,
        { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getMyIcPhoto = () =>
    axiosInstance.get('/User/MyIcPhoto', { responseType: 'blob' });
export const deleteMyIcPhoto = () =>
    axiosInstance.delete('/User/DeleteMyIcPhoto');
